import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import {
    usePostIdsHealthcareservicesHcsIdRequesters,
    usePutIdsHealthcareservicesHcsIdRequestersId,
} from '@toktokdoctech/tokapi-client'
import { useAppDispatch } from '../store'
import { useRequesterFormContext } from '../components/Requester/utils/requesterFormContext'
import { displaySnackbar } from '../actions/main'
import useUserFormGlobalError from '../components/User/utils/useUserFormGlobalError'
import useCurrentHcs from './useCurrentHcs'
import { GLOBAL_ERROR_MESSAGE } from '../components/Requester/utils/_utils'
import { handleExternal } from '../routers/_props'

export const useRequesterMutation = (editMode: boolean, isExternal?: boolean) => {
    const queryClient = useQueryClient()
    const healthCareService = useCurrentHcs()

    const { update } = useRequesterFormContext()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { setGlobaleErrorMessage } = useUserFormGlobalError()

    const createMutationOptions = (successMessage: string) => ({
        onMutate: () => update({ isLoading: true, loaderMessage: 'Enregistrement du requérant' }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['requesters', healthCareService?.id] })
            dispatch(displaySnackbar('success', successMessage))
            if (isExternal) {
                handleExternal('save', 'ok')
                return
            }
            queryClient.invalidateQueries({ queryKey: ['requesters', healthCareService?.id] })
            dispatch(displaySnackbar('success', successMessage))
            navigate('/requesters')
        },
        onError: (err: any) => {
            let message = err instanceof Error ? err.message : GLOBAL_ERROR_MESSAGE
            const statusCode = err?.response?.status

            if (statusCode === 409) {
                message =
                    'Ce requérant est déjà existant dans la liste. Vous pouvez "annuler" pour quitter la saisie du formulaire'
            }

            dispatch(displaySnackbar('error', message))
            setGlobaleErrorMessage(message)
        },
        onSettled: () => update({ isLoading: false, loaderMessage: undefined }),
    })

    const creationMutation = usePostIdsHealthcareservicesHcsIdRequesters({
        mutation: createMutationOptions('Le requérant a bien été ajouté !'),
    })

    const updateMutation = usePutIdsHealthcareservicesHcsIdRequestersId({
        mutation: createMutationOptions('Le requérant a bien été mis à jour !'),
    })

    const mutation = editMode ? updateMutation : creationMutation

    return { mutate: mutation.mutate, isPending: mutation.isPending, isError: mutation.isError }
}
